<template>
  <BlkIcon v-bind="$attrs" viewBox="0 0 24 24">
    <rect y="0" width="24" height="24" fill="white"/>
  </BlkIcon>
</template>

<script>
export default { inheritAttrs: false }
</script>
